import * as types from '../eventsActions';
import store from 'src/store';

const productImpression = (payload: any) => {
  return {
    type: types.PRODUCT_IMPRESSIONS,
    payload
  };
};

const productClick = (payload: any) => {
  return {
    type: types.PRODUCT_CLICK,
    payload
  };
};

const productDetail = (payload: any) => {
  return {
    type: types.PRODUCT_DETAIL,
    payload
  };
};

const searchByCategory = () => {
  const storeData = store.getState();
  return (dispatch: any) => {
    dispatch(shopByCateggoryImpression(storeData.categories));
    dispatch(shopByCategoryPageView(storeData.categories));
  };
};

const shopByCateggoryImpression = (payload: any) => {
  return {
    type: types.SHOP_BY_CATEGORY,
    payload
  };
};

const shopByCategoryPageView = (payload: any) => {
  return {
    type: types.SHOP_BY_CATEGORY_PAGEVIEW,
    payload
  };
};

const placeOrderConfirmation = (payload: any) => {
  return {
    type: types.PLACE_ORDER_CONFIRMATION,
    payload
  };
};

const searchResultImpressions = (payload: any) => {
  return {
    type: types.SEARCH_RESULT_IMPRESSIONS,
    payload
  };
};

const searchResultProductClick = (payload: any) => {
  return {
    type: types.SEARCH_RESULT_PRODUCT_CLICK,
    payload
  };
};

const productAddToCart = (payload: any) => {
  return {
    type: types.PRODUCT_ADD_TO_CART,
    payload
  };
};

const productAddSimpleToCart = (payload: any) => {
  return {
    type: types.PRODUCT_ADD_SIMPLE_TO_CART,
    payload
  };
};

const productAddToCartFromFavoritesPage = (payload: any) => {
  return {
    type: types.PRODUCT_ADD_TO_CART_FROM_FAVORITE_PAGE,
    payload
  };
};

const productAddListToCartFromFavoritesPage = (items: any[]) => {
  return {
    type: types.PRODUCT_ADD_LIST_TO_CART_FROM_FAVORITE_PAGE,
    items
  };
};

const productRemoveFromCart = (payload: any) => {
  return {
    type: types.PRODUCT_REMOVE_FROM_CART,
    payload
  };
};

const checkoutStep = (payload: any) => {
  return {
    type: types.CHECKOUT_STEP,
    payload
  };
};

const sendUserData = (payload: any) => {
  return {
    type: types.SEND_USER_DATA,
    payload
  };
};

const sendModelProductImpression = (payload: any) => {
  return {
    type: types.SEND_MODEL_PRODUCT_IMPRESSION,
    payload
  };
};

const storeModelDiagramProductData = (payload: any) => {
  return {
    type: types.STORE_MODEL_DIAGRAM_PRODUCT_DATA,
    payload
  };
};

const sendModelDiagramProductImpression = (payload: any) => {
  return {
    type: types.SEND_MODEL_DIAGRAM_PRODUCT_IMPRESSION,
    payload
  };
};

const modelDiagramProductClick = (payload: any) => {
  return {
    type: types.MODEL_DIAGRAM_PRODUCT_CLICK,
    payload
  };
};

const getPaymentMethodForCheckout = (payload: any) => {
  return {
    type: types.GET_PAYMENT_METHOD_CHECKOUT,
    payload
  };
};

const productReturns = (payload: any) => {
  return {
    type: types.PRODUCT_RETURNS,
    payload
  };
};

const selectedModelInformation = (payload: any) => {
  return {
    type: types.SELECTED_MODEL_INFORMATION,
    payload
  };
};

const productUploadFileAddToCart = (payload: any) => {
  return {
    type: types.PRODUCT_UPLOAD_FILE_ADD_TO_CART,
    payload
  };
};

const categoriesProductClick = (payload: any) => {
  return {
    type: types.CATEGORIES_PRODUCT_CLICK,
    payload
  };
};

const rmaReturns = (
  payload: any,
  event: string,
  rmaNumber: string,
  returnOption: string
) => {
  return {
    type: types.RMA_RETURNS_INFORMATION,
    payload,
    event,
    rmaNumber,
    returnOption
  };
};

const getItemsInCartInfo = (payload: any) => {
  return {
    type: types.GET_ITEMS_IN_CART_INFO,
    payload
  };
};

const updateCartItemQuantity = (payload: any) => {
  return {
    type: types.UPDATE_CART_ITEM_QTY,
    payload
  };
};

const clearAllItemsFromCart = () => {
  return {
    type: types.CLEAR_ALL_ITEMS_FROM_CART
  };
};

export default {
  productImpression,
  productClick,
  productDetail,
  searchByCategory,
  placeOrderConfirmation,
  searchResultImpressions,
  searchResultProductClick,
  productAddToCart,
  productAddSimpleToCart,
  productAddToCartFromFavoritesPage,
  productAddListToCartFromFavoritesPage,
  productRemoveFromCart,
  checkoutStep,
  sendUserData,
  sendModelProductImpression,
  storeModelDiagramProductData,
  sendModelDiagramProductImpression,
  modelDiagramProductClick,
  getPaymentMethodForCheckout,
  productReturns,
  selectedModelInformation,
  productUploadFileAddToCart,
  categoriesProductClick,
  rmaReturns,
  getItemsInCartInfo,
  updateCartItemQuantity,
  clearAllItemsFromCart
};
